export type SliceRunMode = 'manual' | 'autoplay';

export interface SliceRouteOptions {
  useSliceMode: boolean;
  autostart: boolean;
  runMode: SliceRunMode;
}

export function parseSliceRunMode(
  rawValue: string | null | undefined,
  fallback: SliceRunMode = 'manual'
): SliceRunMode {
  if (rawValue === 'manual' || rawValue === 'autoplay') {
    return rawValue;
  }
  return fallback;
}

export function parseSliceRouteOptions(search: string): SliceRouteOptions {
  const params = new URLSearchParams(search);
  const useSliceMode = params.get('mode') === 'slice';
  const autostart = params.get('autostart') !== '0';
  const defaultRunMode: SliceRunMode = autostart ? 'autoplay' : 'manual';
  const runMode = parseSliceRunMode(params.get('sliceRun'), defaultRunMode);

  return {
    useSliceMode,
    autostart,
    runMode,
  };
}
